module.exports = __webpack_public_path__ + "img/20190711164128854.276f2014.png";